import React from "react";
import "./Expertise.css";
import { useTranslation } from "react-i18next";

const Content2 = () => {
  const { t } = useTranslation();
  return (
    <div id="expertise" className="main-block">
      <div className="left-block">
        <h2>{t('Who we are')}</h2>
        <p>
          {/* JaiyqDev is a global technology partner leading change in
          transforming industries <br /> and generating long-lasting value for
          businesses, people, and the global community. <br /> They trust us
          with finding solutions to the toughest challenges and breaking
          constraints <br /> on their way to meaningful innovation in a dynamic
          market environment. <br /> Based on 20 years of market experience,
          JaiqDev people-centric approach <br /> and passion for client
          success unite engineers, creators, and innovators across Europe,{" "}
          <br /> North America, and the Middle East. */}

          {t('Who we are Text1')}<br /> {t('Who we are Text2')} <br /> {t("Who we are Text3")}
        </p>
        <div className="row space-between about-stats">
          <div className="about-stats-item">
            <h3>40</h3>
            <p>
              {/* Engineers <br /> in-house */}
              {t('Engineers Text1')} <br /> {t('Engineers Text2')}
            </p>
          </div>
          <div className="about-stats-item">
            <h3>7</h3>
            <p>
              {/* Countries where <br /> client are located */}
              {t("Expertise/Countries Text1")} <br /> {t("Expertise/Countries Text2")}
            </p>
          </div>
          <div className="about-stats-item">
            <h3>10</h3>
            <p>
              {/* Years of <br /> experience */}
              {t('Expertise/Experience Text1')} <br /> {t('Expertise/Experience Text2')}
            </p>
          </div>
          <div className="about-stats-item">
            <h3>60%</h3>
            <p>
              {/* Senior <br /> engineers */}
              {t('Expertise/Senior Text1')} <br /> {t("Expertise/Senior Text2")}
            </p>
          </div>
        </div>
        <div className="bottom-text">
          {/* <h4>Our missions:</h4> */}
          <h4>{t('Expertise/Our missions Text1')}</h4>
          <p>
            {/* We breath life into great ideas with
            <br /> the power of digital technology */}
            {t('Expertise/Our missions Text2')}
            <br /> {t('Expertise/Our missions Text3')}
          </p>
        </div>
      </div>
      <div className="right-block">
        <img
          src={require("../../../assets/images/homelogo.png")}
          alt="no photo"
        />
      </div>
    </div>
  );
};

export default Content2;
